// Role i uprawnienia (P7: kupujący ma wszystko, pracownik okrojony). Jedna tabela dla widoków i dla zapisu zdarzeń.
// Na tym etapie sprawdzane w aplikacji; po przejściu na serwer te same reguły trafią do zasad bazy (RLS), bo aplikacji na telefonie nie można ufać.
import { TYPY } from './zdarzenia.js';

export const ROLE = {
  wlasciciel: { pl: 'Właściciel firmy', opis: 'wszystko, także osoby i role' },
  kierownik: { pl: 'Kierownik budowy', opis: 'budowy, dokumenty, zatwierdzanie zmian, obmiar, pisma' },
  brygadzista: { pl: 'Brygadzista', opis: 'jak monter, plus protokół pomiarów i zdjęcie blokady' },
  monter: { pl: 'Monter', opis: 'odhaczanie prac, pomiary, propozycje zmian, blokady i usterki' },
};
export const KOLEJNOSC_ROL = ['wlasciciel', 'kierownik', 'brygadzista', 'monter'];

const WSZYSCY = ['wlasciciel', 'kierownik', 'brygadzista', 'monter'];
const KIER = ['wlasciciel', 'kierownik'];
const BRYG = ['wlasciciel', 'kierownik', 'brygadzista'];

// akcja → role, które mogą ją wykonać (ustawienia domyślne do zatwierdzenia przez Jacka)
export const UPRAWNIENIA = {
  'budowa.tworz': KIER, 'budowa.zmien': KIER,
  'dokument.dodaj': KIER, 'dokument.zmien': KIER,
  'plan.struktura': KIER, // piętra, pomieszczenia, obwody, punkty, trasy (wczytanie budowy, budowa demonstracyjna)
  'praca.odhacz': WSZYSCY, 'pomiar.zapisz': WSZYSCY,
  'zmiana.zaproponuj': WSZYSCY, 'zmiana.zatwierdz': KIER,
  'blokada.zglos': WSZYSCY, 'blokada.zdejmij': BRYG,
  'usterka.dodaj': WSZYSCY, 'usterka.usun': WSZYSCY,
  'protokol.pobierz': BRYG, 'obmiar.pobierz': KIER, 'pismo.pobierz': KIER, 'odbior.zapisz': KIER,
  'osoby.zarzadzaj': ['wlasciciel'],
};

export const moze = (rola, akcja) => !!UPRAWNIENIA[akcja]?.includes(rola);

// typ zdarzenia → akcja (strażnik zapisu: żadne zdarzenie nie przejdzie bez uprawnienia, także spoza widoku)
const AKCJA_TYPU = {
  [TYPY.BUDOWA_UTWORZONA]: 'budowa.tworz', [TYPY.BUDOWA_ZMIENIONA]: 'budowa.zmien', [TYPY.BUDOWA_UKRYTA]: 'budowa.zmien', [TYPY.BUDOWA_PRZYWROCONA]: 'budowa.zmien',
  [TYPY.DOKUMENT_ZMIENIONY]: 'dokument.zmien', [TYPY.DOKUMENT_UKRYTY]: 'dokument.zmien',
  [TYPY.PIETRO_DODANE]: 'plan.struktura', [TYPY.PIETRO_SKALA]: 'plan.struktura', [TYPY.POMIESZCZENIE_DODANE]: 'plan.struktura', [TYPY.POMIESZCZENIE_OBRYS]: 'plan.struktura', [TYPY.ROZDZIELNICA_DODANA]: 'plan.struktura',
  [TYPY.OBWOD_DODANY]: 'plan.struktura', [TYPY.PUNKT_DODANY]: 'plan.struktura', [TYPY.PUNKT_POMIESZCZENIE]: 'plan.struktura', [TYPY.TRASA_DODANA]: 'plan.struktura',
  [TYPY.POMIAR_ZAPISANY]: 'pomiar.zapisz', [TYPY.PRACA_ODHACZONA]: 'praca.odhacz', [TYPY.PRACA_COFNIETA]: 'praca.odhacz',
  [TYPY.ZMIANA_ZAPROPONOWANA]: 'zmiana.zaproponuj', [TYPY.ZMIANA_ZATWIERDZONA]: 'zmiana.zatwierdz', [TYPY.ZMIANA_ODRZUCONA]: 'zmiana.zatwierdz',
  [TYPY.BLOKADA_ZGLOSZONA]: 'blokada.zglos', [TYPY.BLOKADA_ZDJETA]: 'blokada.zdejmij',
  [TYPY.USTERKA_DODANA]: 'usterka.dodaj', [TYPY.USTERKA_USUNIETA]: 'usterka.usun', [TYPY.ODBIOR_ZAPISANY]: 'odbior.zapisz',
  [TYPY.GOTOWOSC_ZGLOSZONA]: 'odbior.zapisz', [TYPY.LV_WCZYTANE]: 'dokument.dodaj', [TYPY.LV_PRZYPISANE]: 'obmiar.pobierz',
};

// dokument.dodany: zwykły dokument budowy tylko kierownik; pliki wytworzone przez aplikację (protokół, pismo, plik miernika) – ten, kto mógł je
// wytworzyć, ale tylko gdy wyglądają jak taki plik: właściwy rodzaj, właściwy folder i bez podmiany planu (pietroId, indeks, zastepuje).
// Inaczej monter mógłby przez bezpośrednie wywołanie API dopisać plan albo podmienić rzut, podpisując go „zrodlo: miernik”. Te same reguły ma serwer.
export const ZRODLA_DOKUMENTOW = {
  protokol: { akcja: 'protokol.pobierz', rodzaj: 'protokol', folder: 'Pomiary\\' },
  miernik: { akcja: 'pomiar.zapisz', rodzaj: 'protokol', folder: 'Pomiary\\Pliki z miernika' },
  pismo: { akcja: 'pismo.pobierz', rodzaj: 'inne', folder: 'Zmiany i pisma\\' },
  odbior: { akcja: 'odbior.zapisz', rodzaj: 'protokol', folder: 'Odbiory' },
};
export const POLA_PLANU = ['pietroId', 'indeks', 'zastepuje'];

export function akcjaZdarzenia(typ, dane = {}) {
  if (typ === TYPY.DOKUMENT_DODANY) {
    const r = Object.hasOwn(ZRODLA_DOKUMENTOW, dane?.zrodlo) ? ZRODLA_DOKUMENTOW[dane.zrodlo] : null;
    const pasuje = r && dane.rodzaj === r.rodzaj && typeof dane.folder === 'string' && dane.folder.startsWith(r.folder) && POLA_PLANU.every((k) => dane[k] == null);
    return pasuje ? r.akcja : 'dokument.dodaj';
  }
  return AKCJA_TYPU[typ] || null;
}

export function sprawdzZapis(rola, typ, dane) {
  const a = akcjaZdarzenia(typ, dane);
  if (!a) throw new Error(`nieznany typ zdarzenia dla uprawnień: ${typ}`);
  if (!moze(rola, a)) { const e = new Error(`Twoja rola (${ROLE[rola]?.pl || rola}) nie pozwala na: ${a}`); e.brakUprawnien = true; throw e; }
}
